import { getRandomInteger } from '../../scripts/utils';

const accordionClass = 'c-accordion';
const accordionOpenClass = accordionClass + '--open';

const accordionJsClass = 'js-accordion';
const accordionOpenByDefaultJsClass = accordionJsClass + '-open-by-default';
const buttonJsClass = accordionJsClass + '-button';
const contentJsClass = accordionJsClass + '-content';

const accordionElements = document.querySelectorAll('.' + accordionJsClass) as NodeListOf<HTMLElement>;

accordionElements.forEach((accordionElement, index: number) => {
    // Wait for the page to fully load
    window.addEventListener('load', () => {
        const buttonElement = accordionElement.querySelector('.' + buttonJsClass) as HTMLElement;
        const contentElement = accordionElement.querySelector('.' + contentJsClass) as HTMLElement;

        if (!buttonElement || !contentElement) {
            return;
        }

        // Add an event listener on the button
        buttonElement.addEventListener('click', () => toggleAccordion(index));

        // Create a unique id for the content
        const randomNumber = getRandomInteger(100000, 999999);
        const contentId = `accordion-content-${randomNumber}`;
        contentElement.id = contentId;

        // Add the aria-controls propery on the button
        buttonElement.setAttribute('aria-controls', contentId);

        // If the accordion is supposed to be open by default
        if (accordionElement.classList.contains(accordionOpenByDefaultJsClass)) {
            // Open it
            toggleAccordion(index);
        }
    });
});

/** Toggle an accordion using it's index or the element. */
export function toggleAccordion (index?: number, element?: HTMLElement): void {
    const accordionElement = typeof index === 'number' ? accordionElements[index] : element;
    const buttonElement = accordionElement.querySelector('.' + buttonJsClass) as HTMLElement;
    const contentElement = accordionElement.querySelector('.' + contentJsClass) as HTMLElement;

    if (!accordionElement || !contentElement) {
        return;
    }

    // If the accordion is open
    if (accordionElement.classList.contains(accordionOpenClass)) {
        // Update the content's inert property to prevent focus
        contentElement.inert = true;

        // Update the content's height to close it
        contentElement.style.height = '0px';

        // Update the aria-expanded property
        buttonElement.setAttribute('aria-expanded', 'false');
    } else {
        // Update the content's inert property to allow focus
        contentElement.inert = false;

        // Update the content's height to open it
        contentElement.style.height = 'initial';

        // Update the aria-expanded property
        buttonElement.setAttribute('aria-expanded', 'true');
    }

    // Toggle the open class
    accordionElement.classList.toggle(accordionOpenClass);
}